import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ScrollFadeIn } from "@/components/effects/ScrollFadeIn";

const faqs = [
  {
    question: "What is 5AM Founders?",
    answer: "5AM Founders is a technical agency that partners with entrepreneurs and founders to build their products. We become your technical team—handling everything from architecture and development to deployment and scaling.",
  },
  {
    question: "What makes you different from other agencies?",
    answer: "We're AI-native and move fast. While traditional agencies take months, we ship MVPs in 2 weeks. No long contracts, no endless meetings—just focused sprints that deliver real results.",
  },
  {
    question: "Which plan is right for me?",
    answer: "Choose MVP Development if you have a tight, well-defined v1 and want to launch fast. Choose Sprints if you need ongoing product, design, and engineering execution every 2 weeks. Choose Enterprise / Complex Builds if the work involves larger scope, multiple systems, migrations, compliance requirements, or a more tailored delivery plan.",
  },
  {
    question: "What types of products can you build?",
    answer: "Anything web-based: AI applications, SaaS platforms, e-commerce stores, booking systems, internal tools, landing pages, mobile-responsive web apps, and more. If it runs in a browser, we can build it.",
  },
  {
    question: "Do you handle domains and hosting?",
    answer: "Yes! We manage the entire technical infrastructure—domain registration, SSL certificates, hosting, deployments, and ongoing maintenance. You never need to touch a server.",
  },
  {
    question: "How does the 2-week sprint work?",
    answer: "We start with priorities, scope the highest-value work, and then execute in a focused 2-week cycle. You get async visibility through the portal, regular updates, and a review at the end of the sprint so we can align on what ships next.",
  },
  {
    question: "Can you scale my product to millions of users?",
    answer: "Absolutely. We architect for scale from day one. Our infrastructure approach handles everything from 1 to 1,000,000+ users without breaking a sweat.",
  },
  {
    question: "What if my project is too large for the fixed plans?",
    answer: "That is exactly what the Enterprise / Complex Builds option is for. If your product needs deeper discovery, custom architecture, phased delivery, larger integrations, or a tailored commercial structure, we scope it separately and send a custom proposal.",
  },
  {
    question: "How does custom pricing work?",
    answer: "For larger or more complex engagements, we price the work after discovery and technical review. That lets us align fees to the actual scope, delivery phases, timeline, and integration complexity instead of forcing the project into a flat package.",
  },
  {
    question: "What if I'm not satisfied with the work?",
    answer: "For MVP Development, we work from a clearly defined scope so expectations stay tight. For Sprints, you can pause or cancel between cycles. For larger custom engagements, scope, milestones, and commercial terms are defined upfront in the proposal and service agreement.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="py-24 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-secondary/20 to-transparent" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <ScrollFadeIn>
          <div className="text-center mb-14">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 font-heading">
              Questions? <span className="text-gradient-indigo">Answers.</span>
            </h2>
          </div>
        </ScrollFadeIn>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <ScrollFadeIn key={index} delay={index * 50}>
              <AccordionItem
                value={`item-${index}`}
                className="glass-card border-none rounded-2xl px-6 sm:px-8 glow-border data-[state=open]:shadow-glow transition-all duration-300"
              >
                <AccordionTrigger className="text-left font-semibold text-lg hover:no-underline py-6 font-heading [&[data-state=open]>svg]:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            </ScrollFadeIn>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
